import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import FlowerButton from "@/components/FlowerButton";
import { useCart } from "@/context/CartContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [tries, setTries] = useState(0);
  const { clear } = useCart();

  useEffect(() => {
    if (!sessionId) { setStatus("missing"); return; }
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") { setStatus("paid"); clear(); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setStatus(data.payment_status); return; }
        if (tries >= 20) { setStatus("timeout"); return; }
        setTimeout(() => setTries((t) => t + 1), 2000);
      } catch {
        if (tries >= 20) { setStatus("error"); return; }
        setTimeout(() => setTries((t) => t + 1), 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [sessionId, tries]);

  const messages = {
    polling: { title: "On confirme ton paiement...", body: "Un tout petit instant, on vérifie que tout est bien passé." },
    paid: { title: "Merci ! Ta commande est confirmée ✿", body: "Un email de confirmation avec ton numéro de commande arrive dans ta boîte. Milo est déjà en train de préparer ton colis !" },
    failed: { title: "Le paiement a échoué", body: "Réessaie ou choisis un autre moyen de paiement." },
    expired: { title: "Session expirée", body: "Ton panier t'attend toujours, tu peux réessayer." },
    timeout: { title: "On patiente encore un peu...", body: "Le paiement met un peu plus de temps. Tu recevras une confirmation par email." },
    error: { title: "Petit souci technique", body: "Ton paiement est peut-être passé — contacte-nous si besoin." },
    missing: { title: "Session introuvable", body: "Aucun identifiant de session dans l'URL." },
  };
  const m = messages[status];

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-20 text-center">
      <span className="daisy-deco mx-auto animate-wiggle" style={{ width: 60, height: 60 }}></span>
      <h1 className="font-cursive text-6xl md:text-7xl text-[#78353A] leading-none mt-6" data-testid="payment-status-title">{m.title}</h1>
      <p className="mt-4 text-[#4A3B32]/85 max-w-md mx-auto leading-relaxed">{m.body}</p>
      <div className="mt-8 flex justify-center gap-4 flex-wrap">
        <Link to="/boutique"><FlowerButton>Continuer les achats</FlowerButton></Link>
        <Link to="/"><FlowerButton variant="sage">Retour accueil</FlowerButton></Link>
      </div>
      {status === "paid" && (
        <p className="mt-6 text-sm text-[#4A3B32]/70">
          Envie de suivre ton colis ? <Link to="/suivi" className="text-[#78353A] underline decoration-dotted underline-offset-4" data-testid="success-suivi-link">Où est mon colis ?</Link>
        </p>
      )}
    </div>
  );
}
